export default (point, pageSerializer) => query => {
  const queryStr = pageSerializer.serialize(query);

  return `${point}${queryStr ? `?${decodeURIComponent(queryStr)}` : ''}`;
};
